// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__14CWQ","Success":"Button_Success__2Pi4h","Danger":"Button_Danger__1405N","fade":"Button_fade__39Vvm"};